import { render, staticRenderFns } from "./CollectHandelSpecSoftTable.vue?vue&type=template&id=b1651a66"
import script from "./CollectHandelSpecSoftTable.vue?vue&type=script&lang=js"
export * from "./CollectHandelSpecSoftTable.vue?vue&type=script&lang=js"
import style0 from "./CollectHandelSpecSoftTable.vue?vue&type=style&index=0&id=b1651a66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports